import { useHistory, useLocation } from 'react-router';
import { useMount } from 'react-use';

import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { visitPaths } from '~libs.desktop.shared.paths';
import {
   getPatientDataAccessModeDefaultValue,
   isPatientDataAccessMode,
   PatientDataAccessMode,
} from '~libs.shared.prescription';

export const useInitialAccessMode = (patientGender: Gender, patientAge: number): PatientDataAccessMode => {
   const history = useHistory();
   const { accessMode } = visitPaths.usePrescriptionsHistoryDownloadSearchParams();
   const location = useLocation();
   const parsedParam = accessMode?.toUpperCase();

   useMount(() => {
      history.replace({
         ...location,
         search: undefined,
      });
   });

   if (!isPatientDataAccessMode(parsedParam)) {
      return 'STANDARD';
   }

   return getPatientDataAccessModeDefaultValue(parsedParam, patientGender, patientAge);
};
